/* eslint-disable max-classes-per-file */
import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

class DiscountEstablishment extends BaseModel {
    @Expose() id = 0;
    @Expose() discountId = 0;
    @Expose() name = "";
    @Expose() address = "";
    @Expose() phone = "";
    @Expose() type = "";
    @Expose() modalType = "";
    @Expose()
    labels: Array<string> = [];
}

export { DiscountEstablishment };
